import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './OffersAndDealsTopPicks.css';
import React, { useContext, useState, useEffect } from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Loader from '../atoms/Loader/Loader';
import OfferAndDeal from '../102_ListingOffersAndDeals/components/OfferAndDeal';
import { LOCAL_STORAGE_TOPPICKS_NAME } from '../TopPicks/TopPicks';
import { TAGS_FOR_PREDEFINED_FACET_NAME, LOCAL_STORAGE_APP_CURRENCY } from '../102_ListingOffersAndDeals/ListingOffersAndDeals';
import { getColorByTheme, getPageThemeColors, get, canUseDOM, hexToRgb, getDictionaryItem } from '../../utils';
import getListing from '../../utils/getListing';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import heartLine from '../../resources/icons/heart-line.svg';
import { commonStyles as checkboxesCommon } from '../Listing/Switch';
import { convertToAnalyticObject } from '../../utils/analytics';
var CheckBox = function CheckBox(_ref) {
  var item = _ref.item,
    index = _ref.index,
    label = _ref.label,
    changeCallback = _ref.changeCallback,
    checked = _ref.checked;
  return /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox__item"
  }, /*#__PURE__*/React.createElement("input", {
    value: item,
    type: "checkbox",
    className: "fp__checkbox",
    id: "oad-toppicks-filter-".concat(TAGS_FOR_PREDEFINED_FACET_NAME, "-").concat(index),
    name: "oad-toppicks-filter-".concat(TAGS_FOR_PREDEFINED_FACET_NAME),
    onChange: function onChange() {
      changeCallback(item);
    },
    checked: checked,
    title: label
  }), /*#__PURE__*/React.createElement("label", {
    className: "body-small g-checkbox__label",
    htmlFor: "oad-toppicks-filter-".concat(TAGS_FOR_PREDEFINED_FACET_NAME, "-").concat(index)
  }, label));
};
var getStorageValues = function getStorageValues() {
  if (canUseDOM) {
    var itemsLS = localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME) || null;
    var items = itemsLS ? JSON.parse(itemsLS) : [];
    return get(items, 'list', []).map(function (item) {
      return "objectID:".concat(item && item.itemId && item.itemId.split('-').join(''));
    }) || [];
  }
  return [];
};
var OffersAndDealsTopPicks = function OffersAndDealsTopPicks(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var language = get(sitecoreContext, 'language') || 'en';
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    emptyError = _useState4[0],
    setemptyError = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    sendRequest = _useState6[0],
    setSendRequest = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    filteringStatements = _useState8[0],
    setFilteringStatements = _useState8[1];
  /* const SearchCount: number = get(params, 'SearchCount') || 12; */
  var indexName = get(params, 'SearchIndex');
  var _useState9 = useState(),
    _useState10 = _slicedToArray(_useState9, 2),
    hits = _useState10[0],
    setHits = _useState10[1];
  /* const [nbHits, setnbHits] = useState<any>(0); */
  /* const [page, setpage] = useState<any>(0); */
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    facets = _useState12[0],
    setFacets = _useState12[1];
  /* const [result, setResult] = useState<any>(); */
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    parsedId = _useState14[0],
    setparsedId = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    overlayButton = _useState16[0],
    setOverlayButton = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    timer = _useState18[0],
    settimer = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    loading = _useState20[0],
    setLoading = _useState20[1];
  var _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    currencyName = _useState22[0],
    setCurrencyName = _useState22[1];
  var dictionary = get(fields, 'data.dictionary');
  var socialSharing = get(fields, 'data.socialSharing');
  var countryItems = get(fields, 'data.countries.countryValues') || [];
  var messageSearchResultEmpty = get(fields, 'data.contextItem.messageSearchResultEmpty.jss.value', '');
  var fromText = getDictionaryItem(dictionary, 'from') || '#';
  var offText = getDictionaryItem(dictionary, 'off') || '#';
  var expiresSoonText = getDictionaryItem(dictionary, 'expiresSoon') || '#';
  var moreInfoText = getDictionaryItem(dictionary, 'moreInfo') || '#';
  var bookNowText = getDictionaryItem(dictionary, 'bookNow') || '#';
  var titleText = getDictionaryItem(dictionary, 'title') || '#';
  var termsAndConditionsText = getDictionaryItem(dictionary, 'termsAndConditions') || '#';
  var readMoreText = getDictionaryItem(dictionary, 'readMore') || '#';
  var readLessText = getDictionaryItem(dictionary, 'readLess') || '#';
  var errorMessage = getDictionaryItem(dictionary, 'notLikedDeals') || '#';
  var offerAndDealCopy = getDictionaryItem(dictionary, 'offerAndDeal') || '#';
  var removedMessage = getDictionaryItem(dictionary, 'hasBeenRemoved') || '#';
  /* const loadMoreText: string = getDictionaryItem(dictionary, 'loadMore') || '#';
  const viewedAmountText: string = getDictionaryItem(dictionary, 'viewedAmount') || '#'; */
  var ratingTextStar = getDictionaryItem(dictionary, 'star') || '';
  var ratingTextStars = getDictionaryItem(dictionary, 'stars') || '';

  /* Params elements */
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  /* End Params elements */

  var variables = BackgroundColorHex ? {
    "--offer-and-deal-toppicks-background-color": BackgroundColorHex,
    "--offer-and-deal-toppicks-background-color-rgb": hexToRgb(BackgroundColorHex, true),
    "--offer-and-deal-toppicks-background-active-color": ActiveColorHex,
    "--offer-and-deal-toppicks-color": ColorHex
  } : {
    "--offer-and-deal-toppicks-background-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--offer-and-deal-toppicks-background-color-rgb": hexToRgb(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary, true),
    "--offer-and-deal-toppicks-background-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--offer-and-deal-toppicks-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  var RemoveButtonOvelray = function RemoveButtonOvelray() {
    return /*#__PURE__*/React.createElement("div", {
      className: "remove-button-overlay ".concat(overlayButton ? ' remove-button-overlay--active' : ''),
      onClick: function onClick() {
        setOverlayButton(false);
        removeItem(parsedId);
        clearTimeout(timer);
      }
    }, "".concat(offerAndDealCopy, " ").concat(removedMessage));
  };
  var types = ['type:Offer And Deal'];
  var generateStatementsForRequest = function generateStatementsForRequest() {
    return filteringStatements.map(function (statement) {
      return "".concat(TAGS_FOR_PREDEFINED_FACET_NAME, ":").concat(statement);
    });
  };

  /* const renderResultsText = () => {
    const loadedHits = (page + 1) * SearchCount;
    return viewedAmountText.replace('{x}', String(loadedHits > nbHits ? nbHits : loadedHits)).replace('{y}', String(nbHits));
  } */

  var removeFav = function removeFav(id) {
    setOverlayButton(false);
    setparsedId(id.split('-').join(''));
    setOverlayButton(true);
    var timer = setTimeout(function () {
      removeItem(id.split('-').join(''));
      setOverlayButton(false);
      clearTimeout(timer);
    }, 2000);
    settimer(timer);
  };
  var removeItem = function removeItem(parsedId) {
    var updatedHits = hits.filter(function (hit) {
      return hit.objectID !== parsedId;
    });
    var objectId = getStorageValues();
    var itemFilters = {
      facets: [TAGS_FOR_PREDEFINED_FACET_NAME],
      facetFilters: [types, _toConsumableArray(objectId)]
      /* hitsPerPage: SearchCount, */
    };
    setLoading(true);
    getListing(indexName, itemFilters).then(function (response) {
      setFilteringStatements(Object.keys(get(response, "facets.".concat(TAGS_FOR_PREDEFINED_FACET_NAME)) || {}));
      setLoading(false);
    }).finally(function () {
      return setLoading(false);
    });
    setTimeout(function () {
      if (updatedHits.length === 0) {
        if (filteringStatements) {
          setemptyError(true);
        }
      }
    }, 10);
    setHits(updatedHits);
  };

  /* const loadMore = (): void => {
    setpage((prevState: any) => prevState + 1);
    const objectId = getStorageValues();
      if (objectId.length === 0) {
      setemptyError(true);
      return;
    }
      const filterParams = generateStatementsForRequest();
    const itemFilters = {
      facets: [TAGS_FOR_PREDEFINED_FACET_NAME],
      facetFilters: [types, [...filterParams], [...objectId]],
      hitsPerPage: SearchCount,
      page: page + 1,
    };
      setLoading(true);
    getListing(indexName, itemFilters).then((response: any) => {
      setResult(response);
      setnbHits(response.nbHits);
      if (hits) {
        setHits(hits.concat(response.hits));
      } else {
        setHits(response.hits);
      }
      setLoading(false);
    });
  }; */

  useEffect(function () {
    if (canUseDOM) {
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
    }
  }, []);
  useEffect(function () {
    var lsCurrency = localStorage.getItem(LOCAL_STORAGE_APP_CURRENCY);
    setCurrencyName(lsCurrency || 'AED');
  }, []);
  useEffect(function () {
    if (sendRequest) {
      setHits([]);
      /* setpage(0); */
      setSendRequest(false);
      var objectId = getStorageValues();
      if (objectId.length === 0) {
        setLoading(false);
        setemptyError(true);
        return;
      }
      var filterParams = generateStatementsForRequest();
      var itemFilters = {
        facets: [TAGS_FOR_PREDEFINED_FACET_NAME],
        facetFilters: [types, _toConsumableArray(filterParams), _toConsumableArray(objectId)]
        /* hitsPerPage: SearchCount, */
      };
      setLoading(true);
      getListing(indexName, itemFilters).then(function (response) {
        setHits(response.hits);
        /* setnbHits(response.nbHits); */
        /* setResult(response); */
        setLoading(false);
      }).finally(function () {
        return setLoading(false);
      });
    }
  }, [sendRequest, filteringStatements]);
  useEffect(function () {
    setLoading(true);
    var objectId = getStorageValues();
    if (objectId.length === 0) {
      setLoading(false);
      setemptyError(true);
      return;
    }
    // let itemFilters: any;

    var itemFilters = {
      facets: [TAGS_FOR_PREDEFINED_FACET_NAME],
      facetFilters: [types, _toConsumableArray(objectId)]
      /* hitsPerPage: SearchCount, */
    };
    getListing(indexName, itemFilters).then(function (response) {
      setHits(response.hits);
      /* setnbHits(response.nbHits); */
      /* setResult(response); */
      setFacets(response.facets);
      setFilteringStatements(Object.keys(get(response, "facets.".concat(TAGS_FOR_PREDEFINED_FACET_NAME)) || {}));
      if (response.hits.length === 0) {
        setemptyError(true);
      }
      setLoading(false);
    }).finally(function () {
      return setLoading(false);
    });
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "row top-picks",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-9 offset-xl-1"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h3"
  }, titleText), emptyError && /*#__PURE__*/React.createElement("p", {
    className: "top-picks__desc"
  }, errorMessage.split('##heart##')[0], " ", /*#__PURE__*/React.createElement("img", {
    className: "icon",
    alt: "icon",
    title: "icon",
    src: heartLine
  }), ' ', errorMessage.split('##heart##')[1]), /*#__PURE__*/React.createElement("div", {
    className: "filters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select"
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox g-checkbox--mob-scroll"
  }, facets && facets[TAGS_FOR_PREDEFINED_FACET_NAME] && Object.keys(facets[TAGS_FOR_PREDEFINED_FACET_NAME]).map(function (facetItemValue, index) {
    return /*#__PURE__*/React.createElement(CheckBox, {
      item: facetItemValue,
      index: index,
      key: index,
      label: facetItemValue,
      checked: filteringStatements.includes(facetItemValue),
      changeCallback: function changeCallback(checkedValue) {
        if (filteringStatements.includes(checkedValue)) {
          //Prevent uncheck all filters
          var newSatements = filteringStatements.filter(function (statement) {
            return statement !== checkedValue;
          });
          if (newSatements.length) {
            setFilteringStatements(newSatements);
            setSendRequest(true);
          }
        } else {
          setFilteringStatements([].concat(_toConsumableArray(filteringStatements), [checkedValue]));
          setSendRequest(true);
        }
      }
    });
  })))), loading && /*#__PURE__*/React.createElement(Loader, {
    color: BackgroundColorHex || primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary
  }), /*#__PURE__*/React.createElement("div", {
    className: "results"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, hits ? hits.length ? hits.map(function (hit, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "OAD-styles col-12 col-sm-6 col-md-4",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: " OAD-item-col "
    }, /*#__PURE__*/React.createElement(OfferAndDeal, {
      fromText: fromText,
      offText: offText,
      expiresSoonText: expiresSoonText,
      moreInfoText: moreInfoText,
      bookNowText: bookNowText,
      readMoreText: readMoreText,
      readLessText: readLessText,
      termsAndConditionsText: termsAndConditionsText,
      deal: hit,
      rtl: rtl,
      currency: currencyName,
      gridMode: false,
      callback: removeFav,
      useTruncate: false,
      socialSharing: socialSharing,
      themeVariables: variables,
      eventsAnalytics: eventsAnalytics,
      params: params,
      ratingTextStars: ratingTextStars,
      ratingTextStar: ratingTextStar,
      countryItems: countryItems
    })));
  }) : '' : '', !loading && (hits && !hits.length || !hits) && /*#__PURE__*/React.createElement("div", {
    className: "message-search-result-empty"
  }, messageSearchResultEmpty), /*#__PURE__*/React.createElement(RemoveButtonOvelray, null))))));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var rtl = _ref3.rtl,
    children = _ref3.children,
    anchorUrlParameter = _ref3.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(checkboxesCommon, " ").concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export default OffersAndDealsTopPicks;
var commonStyles = "chwtowx";
var ltrStyles = "l19yx90h";
var rtlStyles = "r14rpdc7";